export async function runWithConcurrency<T, R>(
  items: readonly T[],
  limit: number,
  worker: (item: T, index: number) => Promise<R>,
): Promise<Array<{ ok: true; value: R } | { ok: false; error: unknown }>> {
  if (items.length === 0) return [];
  const runnerCount = Math.max(1, Math.min(limit, items.length));
  const results: Array<{ ok: true; value: R } | { ok: false; error: unknown }> = new Array(items.length);
  let cursor = 0;
  const runners = Array.from({ length: runnerCount }, async () => {
    while (true) {
      const idx = cursor++;
      if (idx >= items.length) return;
      try {
        const value = await worker(items[idx]!, idx);
        results[idx] = { ok: true, value };
      } catch (error) {
        results[idx] = { ok: false, error };
      }
    }
  });
  await Promise.all(runners);
  return results;
}
